// extracted by mini-css-extract-plugin
export default {"wrap":"sp-z","fullWidth":"tp-z","searchPlacement":"up-z","items":"vp-z","featureCss":"wp-z","disabled":"xp-z","imgCss":"yp-z"};